// Section 16 norms in force and their counters, faction marks. Props only.
import type { NormRow, SocietyVM } from '../../viewModels/society';
import { normText, seasonLabel, societyText } from '../text/en';

interface Props {
  norms: readonly NormRow[];
  factions: SocietyVM['factions'];
}

function NormLine({ n }: { n: NormRow }) {
  const text = normText[n.id];
  return (
    <li class={`society-norm${n.established ? ' is-established' : ''}`}>
      <span class="society-norm__name">{text.label}</span>{' '}
      {n.established ? (
        <>
          <strong>{societyText.normEstablished}</strong>
          {n.since !== null && (
            <span class="society-muted">
              {' '}
              {societyText.normSince(
                societyText.sinceWhen(seasonLabel[n.since.season], n.since.year),
              )}
            </span>
          )}
          <span class="society-muted">
            {' '}
            ({n.announced ? societyText.normAnnounced : societyText.normHidden})
          </span>
          <p class="society-norm__effect">{text.effect}</p>
          {n.fadesIn !== null && <p class="society-muted">{societyText.normFades(n.fadesIn)}</p>}
        </>
      ) : (
        <span class="society-muted">
          <span class="num">{societyText.normProgress(Math.min(n.count, n.needed), n.needed)}</span>
        </span>
      )}
    </li>
  );
}

export function NormsPanel({ norms, factions }: Props) {
  const shown = norms.filter((n) => n.established || n.count > 0);
  return (
    <>
      {shown.length === 0 ? (
        <p class="society-muted">{societyText.normsEmpty}</p>
      ) : (
        <ul class="society-norms">
          {shown.map((n) => (
            <NormLine key={n.id} n={n} />
          ))}
        </ul>
      )}
      <h4>{societyText.factions}</h4>
      {factions.length === 0 ? (
        <p class="society-muted">{societyText.factionsEmpty}</p>
      ) : (
        <ul class="society-list">
          {factions.map((f) => (
            <li key={f.id}>
              {societyText.newcomers(
                societyText.sinceWhen(seasonLabel[f.until.season], f.until.year),
              )}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
